import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin } from 'lucide-react';
import { WhatsAppIcon } from '../components/Logo';
import { Linkedin } from 'lucide-react';

const countryDialCodes = [
  { country: 'Afghanistan', code: '+93' },
  { country: 'Albania', code: '+355' },
  { country: 'Algeria', code: '+213' },
  { country: 'Argentina', code: '+54' },
  { country: 'Armenia', code: '+374' },
  { country: 'Australia', code: '+61' },
  { country: 'Austria', code: '+43' },
  { country: 'Azerbaijan', code: '+994' },
  { country: 'Bahrain', code: '+973' },
  { country: 'Bangladesh', code: '+880' },
  { country: 'Belarus', code: '+375' },
  { country: 'Belgium', code: '+32' },
  { country: 'Bhutan', code: '+975' },
  { country: 'Bolivia', code: '+591' },
  { country: 'Bosnia and Herzegovina', code: '+387' },
  { country: 'Botswana', code: '+267' },
  { country: 'Brazil', code: '+55' },
  { country: 'Brunei', code: '+673' },
  { country: 'Bulgaria', code: '+359' },
  { country: 'Cambodia', code: '+855' },
  { country: 'Cameroon', code: '+237' },
  { country: 'Canada', code: '+1' },
  { country: 'Chile', code: '+56' },
  { country: 'China', code: '+86' },
  { country: 'Colombia', code: '+57' },
  { country: 'Costa Rica', code: '+506' },
  { country: 'Croatia', code: '+385' },
  { country: 'Cyprus', code: '+357' },
  { country: 'Czech Republic', code: '+420' },
  { country: 'Denmark', code: '+45' },
  { country: 'Dominican Republic', code: '+1' },
  { country: 'Ecuador', code: '+593' },
  { country: 'Egypt', code: '+20' },
  { country: 'El Salvador', code: '+503' },
  { country: 'Estonia', code: '+372' },
  { country: 'Ethiopia', code: '+251' },
  { country: 'Finland', code: '+358' },
  { country: 'France', code: '+33' },
  { country: 'Georgia', code: '+995' },
  { country: 'Germany', code: '+49' },
  { country: 'Ghana', code: '+233' },
  { country: 'Greece', code: '+30' },
  { country: 'Guatemala', code: '+502' },
  { country: 'Hong Kong', code: '+852' },
  { country: 'Hungary', code: '+36' },
  { country: 'Iceland', code: '+354' },
  { country: 'India', code: '+91' },
  { country: 'Indonesia', code: '+62' },
  { country: 'Iran', code: '+98' },
  { country: 'Iraq', code: '+964' },
  { country: 'Ireland', code: '+353' },
  { country: 'Israel', code: '+972' },
  { country: 'Italy', code: '+39' },
  { country: 'Jamaica', code: '+1' },
  { country: 'Japan', code: '+81' },
  { country: 'Jordan', code: '+962' },
  { country: 'Kazakhstan', code: '+7' },
  { country: 'Kenya', code: '+254' },
  { country: 'Kuwait', code: '+965' },
  { country: 'Kyrgyzstan', code: '+996' },
  { country: 'Laos', code: '+856' },
  { country: 'Latvia', code: '+371' },
  { country: 'Lebanon', code: '+961' },
  { country: 'Libya', code: '+218' },
  { country: 'Lithuania', code: '+370' },
  { country: 'Luxembourg', code: '+352' },
  { country: 'Macao', code: '+853' },
  { country: 'Malaysia', code: '+60' },
  { country: 'Maldives', code: '+960' },
  { country: 'Malta', code: '+356' },
  { country: 'Mexico', code: '+52' },
  { country: 'Moldova', code: '+373' },
  { country: 'Mongolia', code: '+976' },
  { country: 'Montenegro', code: '+382' },
  { country: 'Morocco', code: '+212' },
  { country: 'Myanmar', code: '+95' },
  { country: 'Nepal', code: '+977' },
  { country: 'Netherlands', code: '+31' },
  { country: 'New Zealand', code: '+64' },
  { country: 'Nigeria', code: '+234' },
  { country: 'North Macedonia', code: '+389' },
  { country: 'Norway', code: '+47' },
  { country: 'Oman', code: '+968' },
  { country: 'Pakistan', code: '+92' },
  { country: 'Panama', code: '+507' },
  { country: 'Paraguay', code: '+595' },
  { country: 'Peru', code: '+51' },
  { country: 'Philippines', code: '+63' },
  { country: 'Poland', code: '+48' },
  { country: 'Portugal', code: '+351' },
  { country: 'Qatar', code: '+974' },
  { country: 'Romania', code: '+40' },
  { country: 'Russia', code: '+7' },
  { country: 'Saudi Arabia', code: '+966' },
  { country: 'Serbia', code: '+381' },
  { country: 'Singapore', code: '+65' },
  { country: 'Slovakia', code: '+421' },
  { country: 'Slovenia', code: '+386' },
  { country: 'South Africa', code: '+27' },
  { country: 'South Korea', code: '+82' },
  { country: 'Spain', code: '+34' },
  { country: 'Sri Lanka', code: '+94' },
  { country: 'Sweden', code: '+46' },
  { country: 'Switzerland', code: '+41' },
  { country: 'Taiwan', code: '+886' },
  { country: 'Tajikistan', code: '+992' },
  { country: 'Tanzania', code: '+255' },
  { country: 'Thailand', code: '+66' },
  { country: 'Tunisia', code: '+216' },
  { country: 'Turkey', code: '+90' },
  { country: 'Turkmenistan', code: '+993' },
  { country: 'Uganda', code: '+256' },
  { country: 'Ukraine', code: '+380' },
  { country: 'United Arab Emirates', code: '+971' },
  { country: 'United Kingdom', code: '+44' },
  { country: 'United States', code: '+1' },
  { country: 'Uruguay', code: '+598' },
  { country: 'Uzbekistan', code: '+998' },
  { country: 'Venezuela', code: '+58' },
  { country: 'Vietnam', code: '+84' },
  { country: 'Yemen', code: '+967' },
  { country: 'Zambia', code: '+260' },
  { country: 'Zimbabwe', code: '+263' },
];

const Contact = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    phoneCountryCode: '+91',
    phoneNumber: '',
    budgetRange: '',
    currency: 'INR',
    otherBudget: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!formState.name.trim()) e.name = 'Name is required';
    if (!formState.email.trim()) e.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formState.email)) e.email = 'Invalid email address';
    if (!formState.phoneNumber.trim()) e.phoneNumber = 'Phone number is required';
    if (!formState.budgetRange) e.budgetRange = 'Budget range is required';
    if (!formState.message.trim()) e.message = 'Message is required';
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((p) => ({
      ...p,
      [name]: value,
      ...(name === 'budgetRange' && value !== 'Other' ? { otherBudget: '' } : {}),
    }));
    if (errors[name]) setErrors((p) => ({ ...p, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) { setErrors(validationErrors); return; }
    setSubmitting(true);
    try {
      const formData = new FormData(e.target);
      await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      });
      window.location.assign('/thank-you');
    } catch {
      // Fallback to browser-native submit so Netlify can still process the form.
      e.target.submit();
    } finally { setSubmitting(false); }
  };

  const inputStyle = (hasError) => ({
    width: '100%',
    background: 'rgba(255,255,255,0.04)',
    border: `1px solid ${hasError ? '#ef4444' : 'rgba(255,255,255,0.1)'}`,
    borderRadius: '10px',
    padding: '14px 18px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.9rem',
    color: '#ffffff',
    outline: 'none',
    transition: 'border-color 0.2s ease',
  });

  return (
    <main data-testid="contact-page">
      <section style={{ background: '#0a0f1e', paddingTop: 'clamp(104px, 15vw, 140px)', paddingBottom: 'clamp(56px, 8vw, 80px)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.span className="section-label" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }}>
            // Get In Touch
          </motion.span>
          <motion.h1
            style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 800, fontSize: 'clamp(2.5rem, 6vw, 5rem)', letterSpacing: '-0.04em', color: '#fff', lineHeight: 1.0, maxWidth: '700px' }}
            initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.15 }}
          >
            Start Your
            <span className="text-gradient-teal"> Project.</span>
          </motion.h1>
        </div>
      </section>

      <section style={{ padding: 'clamp(64px, 8vw, 80px) 0 clamp(80px, 10vw, 120px)', background: '#0a0f1e' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">

            {/* Left: info */}
            <div className="lg:col-span-2">
              <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7, delay: 0.1 }}>
                <h2 style={{ fontFamily: 'Manrope', fontWeight: 700, fontSize: '1.5rem', color: '#fff', marginBottom: '16px', letterSpacing: '-0.02em' }}>
                  Let’s talk about your project
                </h2>
                <p style={{ color: '#64748b', fontFamily: 'Inter', fontSize: '0.9rem', lineHeight: 1.8, marginBottom: '36px' }}>
                  Whether you have a fully scoped brief or just an early idea, we’d love to hear from you. We typically respond within 24 hours.
                </p>

                <div className="flex flex-col gap-5">
                  {/* Email */}
                  <div className="flex items-start gap-4">
                    <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: 'rgba(0,212,170,0.08)', border: '1px solid rgba(0,212,170,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#00d4aa' }}>
                      <Mail size={18} />
                    </div>
                    <div>
                      <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.68rem', color: '#00d4aa', letterSpacing: '0.1em', marginBottom: '3px' }}>Email</p>
                      <a href="mailto:hello@insightsnode.com" style={{ color: '#94a3b8', fontFamily: 'Inter', fontSize: '0.9rem', textDecoration: 'none' }}>
                        hello@insightsnode.com
                      </a>
                    </div>
                  </div>

                  {/* WhatsApp */}
                  <div className="flex items-start gap-4">
                    <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: 'rgba(37,211,102,0.08)', border: '1px solid rgba(37,211,102,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#25d366' }}>
                      <WhatsAppIcon size={18} color="#25d366" />
                    </div>
                    <div>
                      <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.68rem', color: '#25d366', letterSpacing: '0.1em', marginBottom: '3px' }}>WhatsApp</p>
                      <a
                        href="https://wa.me/916289350762"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#94a3b8', fontFamily: 'Inter', fontSize: '0.9rem', textDecoration: 'none', transition: 'color 0.2s ease' }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = '#25d366')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#94a3b8')}
                        data-testid="whatsapp-link"
                      >
                        Open WhatsApp
                      </a>
                    </div>
                  </div>

                  {/* LinkedIn */}
                  <div className="flex items-start gap-4">
                    <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: 'rgba(0,119,181,0.08)', border: '1px solid rgba(0,119,181,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#0077b5' }}>
                      <Linkedin size={18} />
                    </div>
                    <div>
                      <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.68rem', color: '#0077b5', letterSpacing: '0.1em', marginBottom: '3px' }}>LinkedIn</p>
                      <a
                        href="https://www.linkedin.com/company/insightsnode/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#94a3b8', fontFamily: 'Inter', fontSize: '0.9rem', textDecoration: 'none', transition: 'color 0.2s ease' }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = '#0077b5')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#94a3b8')}
                      >
                        InsightsNode on LinkedIn
                      </a>
                    </div>
                  </div>

                  {/* Location */}
                  <div className="flex items-start gap-4">
                    <div style={{ width: '42px', height: '42px', borderRadius: '10px', background: 'rgba(0,212,170,0.08)', border: '1px solid rgba(0,212,170,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#00d4aa' }}>
                      <MapPin size={18} />
                    </div>
                    <div>
                      <p style={{ fontFamily: 'JetBrains Mono', fontSize: '0.68rem', color: '#00d4aa', letterSpacing: '0.1em', marginBottom: '3px' }}>Location</p>
                      <p style={{ color: '#94a3b8', fontFamily: 'Inter', fontSize: '0.9rem' }}>West Bengal, India</p>
                    </div>
                  </div>
                </div>

                {/* Response badge */}
                <div className="glass-card" style={{ padding: '16px 20px', marginTop: '28px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: '9px', height: '9px', borderRadius: '50%', background: '#00d4aa', flexShrink: 0, boxShadow: '0 0 8px rgba(0,212,170,0.5)' }} />
                  <p style={{ fontFamily: 'Inter', fontSize: '0.82rem', color: '#94a3b8' }}>
                    Average response: <strong style={{ color: '#fff' }}>under 24 hours</strong>
                  </p>
                </div>

                {/* WhatsApp CTA */}
                <a
                  href="https://wa.me/916289350762?text=Hi%20InsightsNode!%20I%20have%20a%20project%20I%27d%20like%20to%20discuss."
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    marginTop: '16px', padding: '13px 22px', borderRadius: '50px',
                    background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.25)',
                    color: '#25d366', textDecoration: 'none',
                    fontFamily: 'Manrope', fontWeight: 600, fontSize: '0.9rem',
                    transition: 'background 0.2s ease, border-color 0.2s ease',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(37,211,102,0.18)'; e.currentTarget.style.borderColor = 'rgba(37,211,102,0.5)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(37,211,102,0.1)'; e.currentTarget.style.borderColor = 'rgba(37,211,102,0.25)'; }}
                  data-testid="whatsapp-cta"
                >
                  <WhatsAppIcon size={18} color="#25d366" />
                  Chat on WhatsApp
                </a>
              </motion.div>
            </div>

            {/* Right: form */}
            <div className="lg:col-span-3">
              <motion.div
                className="glass-card"
                style={{ padding: 'clamp(20px, 4vw, 48px)' }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                <form
                  name="contact"
                  method="POST"
                  action="/thank-you"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={handleSubmit}
                  data-testid="contact-form"
                >
                    <input type="hidden" name="form-name" value="contact" />
                    <p style={{ display: 'none' }}><label>Do not fill: <input name="bot-field" onChange={() => {}} /></label></p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                      <div>
                        <label htmlFor="name" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>Name *</label>
                        <input id="name" type="text" name="name" placeholder="Your full name"
                          value={formState.name} onChange={handleChange} style={inputStyle(errors.name)}
                          onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                          onBlur={(e) => (e.target.style.borderColor = errors.name ? '#ef4444' : 'rgba(255,255,255,0.1)')}
                          data-testid="input-name" />
                        {errors.name && <p style={{ color: '#ef4444', fontFamily: 'Inter', fontSize: '0.78rem', marginTop: '5px' }}>{errors.name}</p>}
                      </div>
                      <div>
                        <label htmlFor="email" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>Email *</label>
                        <input id="email" type="email" name="email" placeholder="your@email.com"
                          value={formState.email} onChange={handleChange} style={inputStyle(errors.email)}
                          onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                          onBlur={(e) => (e.target.style.borderColor = errors.email ? '#ef4444' : 'rgba(255,255,255,0.1)')}
                          data-testid="input-email" />
                        {errors.email && <p style={{ color: '#ef4444', fontFamily: 'Inter', fontSize: '0.78rem', marginTop: '5px' }}>{errors.email}</p>}
                      </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                      <label htmlFor="company" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>Company</label>
                      <input id="company" type="text" name="company" placeholder="Your company or startup"
                        value={formState.company} onChange={handleChange} style={inputStyle(false)}
                        onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                        onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.1)')}
                        data-testid="input-company" />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                      <div>
                        <label htmlFor="phoneCountryCode" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>
                          Country Code
                        </label>
                        <select
                          id="phoneCountryCode"
                          name="phoneCountryCode"
                          value={formState.phoneCountryCode}
                          onChange={handleChange}
                          style={inputStyle(false)}
                          onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.1)')}
                        >
                          {countryDialCodes.map((item) => (
                            <option key={`${item.country}-${item.code}`} value={item.code}>
                              {item.code} ({item.country})
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label htmlFor="phoneNumber" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>
                          Phone Number *
                        </label>
                        <input
                          id="phoneNumber"
                          type="tel"
                          name="phoneNumber"
                          placeholder="Enter your phone number"
                          value={formState.phoneNumber}
                          onChange={handleChange}
                          style={inputStyle(errors.phoneNumber)}
                          onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                          onBlur={(e) => (e.target.style.borderColor = errors.phoneNumber ? '#ef4444' : 'rgba(255,255,255,0.1)')}
                        />
                        {errors.phoneNumber && <p style={{ color: '#ef4444', fontFamily: 'Inter', fontSize: '0.78rem', marginTop: '5px' }}>{errors.phoneNumber}</p>}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
                      <div>
                        <label htmlFor="budgetRange" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>Project Budget Range *</label>
                        <select
                          id="budgetRange"
                          name="budgetRange"
                          value={formState.budgetRange}
                          onChange={handleChange}
                          style={inputStyle(errors.budgetRange)}
                          onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                          onBlur={(e) => (e.target.style.borderColor = errors.budgetRange ? '#ef4444' : 'rgba(255,255,255,0.1)')}
                        >
                          <option value="">Select budget range</option>
                          <option value="Under 5,000">Under 5,000</option>
                          <option value="5,000 - 10,000">5,000 - 10,000</option>
                          <option value="10,000 - 25,000">10,000 - 25,000</option>
                          <option value="25,000 - 50,000">25,000 - 50,000</option>
                          <option value="50,000+">50,000+</option>
                          <option value="Other">Other</option>
                        </select>
                        {errors.budgetRange && <p style={{ color: '#ef4444', fontFamily: 'Inter', fontSize: '0.78rem', marginTop: '5px' }}>{errors.budgetRange}</p>}
                      </div>
                      <div>
                        <label htmlFor="currency" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>Currency</label>
                        <select
                          id="currency"
                          name="currency"
                          value={formState.currency}
                          onChange={handleChange}
                          style={inputStyle(false)}
                          onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.1)')}
                        >
                          <option value="INR">INR</option>
                          <option value="USD">USD</option>
                        </select>
                      </div>
                    </div>

                    {formState.budgetRange === 'Other' && (
                      <div style={{ marginBottom: '20px' }}>
                        <label htmlFor="otherBudget" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>
                          Enter Your Budget
                        </label>
                        <input
                          id="otherBudget"
                          type="text"
                          name="otherBudget"
                          placeholder="Enter your budget"
                          value={formState.otherBudget}
                          onChange={handleChange}
                          style={inputStyle(false)}
                          onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                          onBlur={(e) => (e.target.style.borderColor = 'rgba(255,255,255,0.1)')}
                        />
                      </div>
                    )}

                    <div style={{ marginBottom: '28px' }}>
                      <label htmlFor="message" style={{ fontFamily: 'JetBrains Mono', fontSize: '0.7rem', color: '#00d4aa', letterSpacing: '0.1em', display: 'block', marginBottom: '8px' }}>Project Description *</label>
                      <textarea id="message" name="message" rows={6}
                        placeholder="Tell us about your project, goals, and timeline..."
                        value={formState.message} onChange={handleChange}
                        style={{ ...inputStyle(errors.message), resize: 'vertical', minHeight: '140px' }}
                        onFocus={(e) => (e.target.style.borderColor = '#00d4aa')}
                        onBlur={(e) => (e.target.style.borderColor = errors.message ? '#ef4444' : 'rgba(255,255,255,0.1)')}
                        data-testid="input-message" />
                      {errors.message && <p style={{ color: '#ef4444', fontFamily: 'Inter', fontSize: '0.78rem', marginTop: '5px' }}>{errors.message}</p>}
                    </div>

                    <button type="submit" className="btn-primary"
                      style={{ width: '100%', justifyContent: 'center', padding: '16px', fontSize: '0.95rem', opacity: submitting ? 0.7 : 1 }}
                      disabled={submitting} data-testid="submit-btn">
                      {submitting ? 'Sending...' : 'Send Message'}
                    </button>
                </form>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
